import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user // 注册 user 模块
    },

    state: {},
    mutations: {},
    actions: {},
    getters: {}
})

export default store